import AxiosCustom from "./../../../../components/common/apiConfigPouyan/index";


export function send_otp_sejam(payload) {
  const config = {
    url: `/OTP/SendUpdateSejamDataOTP/SendUpdateSejamDataOTP/${payload?.data?.NationalCode}`
  };

  const data = {};

  const header = {
    ...payload?.headers
  }

  return AxiosCustom(config, data, header);
}
